import { render } from "./FosXtremeHeader.vue?vue&type=template&id=f41adc12&scoped=true"
import script from "./FosXtremeHeader.vue?vue&type=script&lang=js"
export * from "./FosXtremeHeader.vue?vue&type=script&lang=js"

import "./FosXtremeHeader.vue?vue&type=style&index=0&id=f41adc12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f41adc12"]])

export default __exports__